// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createPopper } from '@popperjs/core'
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueMask from 'v-mask'
import VTooltip from 'v-tooltip'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import VueHead from 'vue-head'
import Notifications from 'vue-notification'
import VueResource from 'vue-resource'

import App from 'App'
import RichTextEditor from 'components/reused-components/rich-text-editor/RichTextEditor'
import UrlConfig from 'conf/index'
import router from 'router'
import ErrorHandler from 'utils/error-handler'
import { startPageLoader, stopPageLoader } from 'utils/page-loader'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'logger'

Vue.use(VueDOMPurifyHTML, {
  namedConfigurations: {
    plaintext: {
      USE_PROFILES: { html: false },
    },
    ghost: {
      USE_PROFILES: { html: true, svg: true },
      ADD_TAGS: ['iframe', 'button', 'input', 'video', 'audio', 'script'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'preload', 'class'],
    },
  },
})

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(VTooltip)

Vue.use(VueResource)
Vue.use(VueHead)

Vue.use(Notifications)
Vue.use(ErrorHandler)
Vue.use(VueMask)

const { hostname } = window.location
const siteDomain = hostname === 'localhost' ? hostname : `.${hostname}`

const cookiesDefaultConfig = {
  expires: '1y',
  path: '/',
  domain: siteDomain,
  secure: true,
  sameSite: 'Strict',
}

Vue.use(VueCookies, cookiesDefaultConfig)

/* Register custom components */
Vue.component('RichTextEditor', RichTextEditor)

/* Add feature flag to show and hide components in different environments. */
// noinspection JSUnusedGlobalSymbols
Vue.prototype.$featureFlag = {
  ONLY_PROD: process.env.NODE_ENV === 'production',
  ONLY_STAGE: process.env.NODE_ENV === 'stage',
  ONLY_DEV: process.env.NODE_ENV === 'development',
  ONLY_STAGE_AND_DEV: process.env.NODE_ENV === 'stage' || process.env.NODE_ENV === 'development',
}

/* Add http interceptor to control the http requests. */
/* eslint-disable consistent-return */
// noinspection JSUnresolvedVariable,FunctionWithInconsistentReturnsJS
Vue.http.interceptors.push((request, next) => {
  // ignore adding page loader for following routes
  const {
    upload,
    url: { episodes, languages, podcasts },
  } = UrlConfig
  const s3UploadURL = 'https://afripods-data.s3.amazonaws.com'
  const bypassURLs = [languages, `${podcasts}/featured`, `${episodes}/top`, upload.image, upload.audio, s3UploadURL]
  if (bypassURLs.includes(request.url)) return next()

  // show and hide page loaders for all the requests except for bypassURLs
  startPageLoader()
  next(() => {
    stopPageLoader()
  })
})
/* eslint-enable consistent-return */

Vue.filter('stripHTML', (string = '', preserveNewLines = true) => {
  let newString = string.replace(/<(?:br\s?\/?|\/div|\/p)>/g, preserveNewLines ? '\n' : ' ').trim()
  newString = new DOMParser().parseFromString(newString, 'text/html')?.body.textContent || ''
  newString = newString.replace(/\n{2}/g, '\n').trim()

  if (!preserveNewLines) newString = newString.replace(/\s+/g, ' ').trim()

  return newString
})

Vue.filter('highlightString', (string = '', query = '') => {
  if (!query) return string
  const queryRegex = new RegExp(query, 'gi')

  return string.replace(queryRegex, '<span class="highlight">$&</span>')
})

/* eslint-disable no-new */
// noinspection ObjectAllocationIgnored
new Vue({
  el: '#app',
  router,
  components: { App, createPopper },
  template: '<App/>',
  pinia,
})
/* eslint-enable no-new */



// WEBPACK FOOTER //
// ./src/main.js